import { render, staticRenderFns } from "./InitDataGroup.vue?vue&type=template&id=021bc768&scoped=true&"
import script from "./InitDataGroup.vue?vue&type=script&lang=js&"
export * from "./InitDataGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021bc768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021bc768')) {
      api.createRecord('021bc768', component.options)
    } else {
      api.reload('021bc768', component.options)
    }
    module.hot.accept("./InitDataGroup.vue?vue&type=template&id=021bc768&scoped=true&", function () {
      api.rerender('021bc768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/sysMenu/InitDataGroup.vue"
export default component.exports